export const BOOK_SKI_PASS_STORAGE_KEY = 'book-ski-pass-storage';
export const CHECKOUT_STORAGE_KEY = 'b2c-checkout-session';
export const CHECKOUT_URL_STORAGE_KEY = 'b2c-checkout-url';
export const ROUTE_RESTORATION_FLAG = 'route-restored';
